/*
 Due to batching we sometimes get ordinance info for the spouses in different batches resulting in an SS for each spouse pid, this removes any duplicate SS. See TW-5824.
 */
export default function removeDuplicateSS(rows) {
  const sealingToSpousePrimaryIds = []

  return rows.filter((ordRow) => {
    if (ordRow.type === 'sealingToSpouse') {
      const spouse1Id = ordRow.person.id
      const spouse2Id = ordRow.ordinances.sealingToSpouse.relationships.spouseId
      if (
        sealingToSpousePrimaryIds.some((spousePidsArray) =>
          spousePidsArray.every((id) => id === spouse1Id || id === spouse2Id)
        )
      ) {
        return false
      }
      sealingToSpousePrimaryIds.push([spouse1Id, spouse2Id])
    }
    return true
  })
}
